import Vue from "vue"
import VueI18n from "vue-i18n"

Vue.use(VueI18n)

const i18n = new VueI18n({
  messages: {
    en: require("./translations/en.json"),
    de: require("./translations/de.json")
  },
  locale: "en"
})

export default i18n